export type SocialPostType = 'idea' | 'roi' | 'strategy' | 'news' | 'market' | 'activity';
export type SocialProfileType =
    | 'posts'
    | 'comments'
    | 'likes'
    | 'positions'
    | 'bookmarks'
    | 'top_categories'
    | 'activity';

export enum CreatePostMarketStep {
    TITLE = 'title',
    CASE = 'case',
    SETTLEMENT = 'settlement',
}

export const MAX_POST_CONTENT_CHARACTERS = 400;
export const MAX_POST_TITLE_CHARACTERS = 100;

/**
 * Bottom rootMargin for social feed infinite scroll: the next page starts
 * fetching this far below the viewport (matches the portfolio lists'
 * 1600px prefetch distance).
 */
export const SOCIAL_FEED_PREFETCH_ROOT_MARGIN = '0px 0px 1600px 0px';
